export const brl = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const fdate = (v) => {
  if (!v) return "—";
  const s = String(v);
  if (/^\d{4}-\d{2}$/.test(s)) return `${s.slice(5, 7)}/${s.slice(0, 4)}`;
  const d = new Date(s.length === 10 ? `${s}T12:00:00` : s);
  return isNaN(d) ? s : d.toLocaleDateString("pt-BR");
};

export const cnpjMask = (v = "") => {
  const d = String(v).replace(/\D/g, "").slice(0, 14);
  return d.replace(/^(\d{2})(\d)/, "$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1/$2").replace(/(\d{4})(\d)/, "$1-$2");
};

export const validCnpj = (v) => {
  const d = String(v).replace(/\D/g, "");
  if (d.length !== 14 || /^(\d)\1+$/.test(d)) return false;
  const calc = (base, w) => { const s = base.split("").reduce((a, n, i) => a + Number(n) * w[i], 0) % 11; return s < 2 ? 0 : 11 - s; };
  const w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const d1 = calc(d.slice(0, 12), w1);
  const d2 = calc(d.slice(0, 12) + d1, [6, ...w1]);
  return d.endsWith(`${d1}${d2}`);
};

const TONES = {
  ok: "bg-[#DDFDE5] text-[#0E6224]",
  warn: "bg-[#FEF3C7] text-[#92400E]",
  err: "bg-[#FDE8E8] text-[#9B1C1C]",
  info: "bg-[#E0F2FE] text-[#075985]",
  mute: "bg-[#EAEFF2] text-[#587178]",
};
const MAP = {
  pago: "ok", recebido: "ok", paga: "ok", entregue: "ok", aprovada: "ok", ativo: "ok", ativa: "ok", atendida: "ok", resolvido: "ok",
  concluida: "ok", fechado: "ok", verificado: "ok", authorized: "ok", importada: "info", PRODUCAO: "ok",
  pendente: "warn", disponivel: "warn", aguardando_conferencia: "warn", em_andamento: "info", em_revisao: "info", aberto: "info",
  aberta: "info", estimativa: "warn", rascunho: "mute", aguardando_validacao: "warn", pronta_transmissao: "info", convidado: "warn",
  pendente_autorizacao: "warn", em_analise: "info", nao_verificado: "warn", demonstracao: "info", DEMONSTRACAO: "info", HOMOLOGACAO: "info",
  vencida: "err", rejeitada: "err", cancelada: "mute", cancelado: "mute", cancelled: "mute", revogado: "err", recusado: "err",
  rejeitado: "err", NAO_CONFIGURADA: "mute", demonstrativa: "mute", alta: "err", media: "warn", baixa: "mute", pending: "warn",
  excluido: "err", excluida: "err", removido: "mute",
};
const LABELS = {
  aguardando_conferencia: "Aguardando conferência", pronta_transmissao: "Pronta p/ transmissão", aguardando_validacao: "Aguardando validação",
  em_andamento: "Em andamento", em_revisao: "Em revisão", pendente_autorizacao: "Aguardando autorização", nao_verificado: "CRC não verificado",
  em_analise: "Em análise", verificado: "CRC verificado", demonstracao: "Demonstração", NAO_CONFIGURADA: "Não configurada",
  DEMONSTRACAO: "Demonstração", HOMOLOGACAO: "Homologação", PRODUCAO: "Produção", disponivel: "Disponível", authorized: "Autorizada",
  cancelled: "Cancelada", pending: "Pendente", media: "Média", empresario: "Empresário", colaborador_editor: "Colaborador (editor)",
  colaborador_leitura: "Colaborador (leitura)", org_admin: "Admin. da organização", contador: "Contador", analista_fiscal: "Analista fiscal",
  dp: "Departamento pessoal", superadmin: "Superadministrador", admin_operacional: "Administrador operacional", suporte: "Suporte",
  excluido: "Excluído", excluida: "Excluída",
};
export const label = (s) => LABELS[s] || (s ? String(s).charAt(0).toUpperCase() + String(s).slice(1).replace(/_/g, " ") : "—");
export const tone = (s) => TONES[MAP[s] || "mute"];
